<template>
  <div class="app-logo">
    <strong>
      <img class="app-logo__gucci" src="/img/icons/gucci-grove-logo.png" alt="Gucci Grove Logo">
    </strong>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
};
</script>

<style lang="scss" scoped>
.app-logo {
  position: relative;
  width: 21.5vh;

  @include mq($until: ipadP) {
    width: 38vw;
  }

  strong {
    position: relative;
    width: 100%;

    img {
      display: block;
      position: relative;
      width: 100%;
    }
  }
}
</style>
